import router from '../../router/router';
import { routes } from '../../router/routes';

// resources:
//  https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507
//  https://stackoverflow.com/questions/46234832/structuring-a-vuex-module

const state = {

    topHeaderOpen : true,
    sideNavOpen   : false,
    overflowOpen  : false,
    intendedRoute : null,
    routes
};

const mutations = {

    toggleSideNav( state ){

        state.sideNavOpen = !state.sideNavOpen;
    },
    toggleTopHeader( state, input ){

        state.topHeaderOpen = input;
    },
    toggleOverflow( state ){

        state.overflowOpen = !state.overflowOpen;
    },
    closeOverflow( state ){

        state.overflowOpen = false;
    },
    backDropClicked( state ){

        if( state.sideNavOpen ) state.sideNavOpen = !state.sideNavOpen;
    },
    saveIntendedRoute( state, routeName ){

        state.intendedRoute = routeName;
    }
};

const actions = {

    toggleSideNav( { commit } ){

        commit( 'toggleSideNav' );
        commit( 'toggleBackdrop', null, { root: true } );
    },
    sideNavRouting( { commit }, route ){

        commit( 'toggleSideNav' );
        commit( 'toggleBackdrop', null, { root: true } );
        commit( 'orderMenu/clearEditing', null, { root: true } );
        router.replace( { name : route } );
    },
    toggleOverflow( { commit } ){

        commit( 'toggleOverflow' );
    },
    closeOverflow( { commit } ){

        commit( 'closeOverflow' );
    },
    hideHeader( { commit } ){

        commit( 'toggleTopHeader', false );
    },
    showHeader( { commit } ){

        commit( 'toggleTopHeader', true );
    },
    saveIntendedRoute( { commit }, routeName ){

        commit( 'saveIntendedRoute', routeName );
    }
};

const getters = {

    topHeaderOpen : state => state.topHeaderOpen,
    sideNavOpen   : state => state.sideNavOpen,
    overflowOpen  : state => state.overflowOpen,
    intendedRoute : state => state.intendedRoute,
    routes        : state => state.routes
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};